import React, { useContext } from 'react';
import slugify from 'slugify';
import styled from 'styled-components';
import { UserContext } from '../../../../context/UserContext';
import { Badge } from '../../../ui';
import AdminSwitch from './AdminSwitch';
import RemoveMemberButton from './RemoveMemberButton';

const MemberListItem: any = styled.li.attrs({
  className: 'f6 pv2 bt b--light-gray flex items-center justify-between'
})``;

interface MemberListProps {
  account: {
    id: string;
    owner: {
      id: string;
    };
  };
  accountMembers: {
    id: string;
    membershipStatus: string;
    displayName: string;
    roleType: string;
    user: { id: string; email: string };
  }[];
  userIsAdmin: boolean;
}

const MemberList: React.FC<MemberListProps> = ({ account, accountMembers, userIsAdmin }) => {
  const { user } = useContext(UserContext);

  return (
    <div className="bt b--light-gray">
      <p className="f7 tr mv2 fw5">Admin</p>
      {accountMembers
        .filter(member => member.membershipStatus !== 'INACTIVE')
        .map(member => (
          <MemberListItem
            member={member}
            key={member.id}
            data-testid={`member-${slugify(member.displayName)}`}
          >
            <div className="flex items-center">
              {userIsAdmin && user.id !== member.user.id && (
                <div className="mr1">
                  <RemoveMemberButton account={account} member={member} />
                </div>
              )}
              <span className="mr1">{member.displayName || member.user.email}</span>
              {member.membershipStatus === 'PENDING' && (
                <Badge className="ml1" data-testid="pending">
                  Pending
                </Badge>
              )}
            </div>

            <AdminSwitch member={member} disabled={!userIsAdmin || user.id === member.user.id} />
          </MemberListItem>
        ))}
    </div>
  );
};

export default MemberList;
